import styled from 'styled-components';

export const PostCount = styled('div')`
  color: grey;
  font-size: 80%;
`;
